import React from "react";
import styled from "styled-components";
/* import {Grid, Col} from "../../styles/Grid";
import {TextArea} from "../../styles/Forms";
import {AppButton, ButtonWithIcon} from "../../styles/Butttons";
import {Label} from "../forms/DynamicInput";
import {ReactComponent as EditIcon} from "../../assets/icons/edit.svg";*/
import {ReactComponent as EditIcon} from "../../../assets/icons/edit.svg";
// import EditableImg from "../../forms/EditableImg";
import parse from "html-react-parser";
import {Grid, Col} from "../../../styles/Grid";
import {AppButton, ButtonWithIcon} from "../../../styles/Butttons";
import {TextArea} from "../../../styles/Forms";
import {Label} from "../../../components/forms/DynamicInput";
import EditableImg from "../../../components/forms/EditableImg";

export default function GetForm({editable, save, data, titleDesc, change, video, nameUpdate}) {
   return (
      <>
         {editable ? (
            <EditMode data={data} titleDesc={titleDesc} save={save} video={video} nameUpdate={nameUpdate} />
         ) : (
            <ReadMode data={data} changeEdit={change} titleDesc={titleDesc} video={video} nameUpdate={nameUpdate} />
         )}
      </>
   );
}

const EditMode = ({data, titleDesc, save, video, nameUpdate}) => {
   if (!data) return null;
   return (
      <>
         <SecBody onSubmit={save} as="form">
            <Grid>
               <Col large="12">
                  <Label className="labelMargin">{titleDesc}:</Label>
               </Col>
               <Col large="9">
                  <TextArea
                     as="textarea"
                     defaultValue={data.description ? data.description.replace(/<br>/g, "\n") : ""}
                     name="longDescription"
                  ></TextArea>
               </Col>
               <Col large="12" />
            </Grid>
            <Grid>
               {video && (
                  <>
                     <Col large="12">
                        <Label className="labelTitle">Video</Label>
                     </Col>
                     <Col large="12">
                        <Grid className="imagesInput">
                           <Col large="6">
                              <EditableImg
                                 type="video"
                                 name={`video${nameUpdate}`}
                                 fileName={data.pathVideo}
                                 editable={true}
                                 title="Video"
                                 label="Video"
                              />
                           </Col>
                        </Grid>
                     </Col>
                  </>
               )}
               <div className="division" />
               <Col large="12">
                  <Label className="labelTitle">Imagen de portada</Label>
               </Col>
               <Col large="12">
                  <Grid className="imagesInput">
                     <Col large="6">
                        <EditableImg
                           name={`desk${nameUpdate}`}
                           fileName={data.pathImageWebDesktop}
                           editable={true}
                           title="Desktop"
                           label="Desktop medidas aprox 1024px X 768px"
                        />
                     </Col>
                     <Col large="6">
                        <EditableImg
                           name={`mobile${nameUpdate}`}
                           fileName={data.pathImageWebMobile}
                           editable={true}
                           title="Mobile"
                           label="Mobile medidas aprox 510px X 428px"
                        />
                     </Col>
                  </Grid>
               </Col>
               <Col large="2" offsetL="10" style={{marginTop: "1.5em"}}>
                  <AppButton>GUARDAR</AppButton>
               </Col>
            </Grid>
         </SecBody>
      </>
   );
};

const ReadMode = ({data, titleDesc, changeEdit, video, nameUpdate}) => {
   if (!data) return null;
   return (
      <>
         <SecBody>
            <Grid>
               <Col large="12">
                  <Label className="labelMargin">{titleDesc}:</Label>
               </Col>
               <Col large="11">
                  <Label className="labelText">{data.description || "Ingresa una descripción o texto"}</Label>
               </Col>{" "}
               <Col large="1">
                  <ButtonWithIcon text="" Icon={EditIcon} right={true} action={changeEdit} />
               </Col>
            </Grid>
         </SecBody>
         <SecBody>
            <Grid>
               {video && (
                  <>
                     <Col large="12">
                        <Label className="labelTitle">{video ? "Video" : "Imagen de portada"}</Label>
                     </Col>
                     <Col large="12">
                        <Grid className="imagesInput">
                           <Col large="6">
                              <EditableImg name={`pathVideo`} fileName={data.pathVideo} editable={false} title="Video" label="Video" />
                           </Col>
                        </Grid>
                     </Col>
                  </>
               )}
               <div className="division" />
               <Col large="12">
                  <Label className="labelTitle">Imagen de portada</Label>
               </Col>
               <Col large="12">
                  <Grid className="imagesInput">
                     <Col large="6">
                        <EditableImg
                           name={`pathImageWebDesktop`}
                           fileName={data.pathImageWebDesktop}
                           editable={false}
                           title="Desktop"
                           label="Desktop medidas aprox 1024px X 768px"
                        />
                     </Col>
                     <Col large="6">
                        <EditableImg
                           name={`pathImageWebMobile`}
                           fileName={data.pathImageWebMobile}
                           editable={false}
                           title="Mobile"
                           label="Mobile medidas aprox 510px X 428px"
                        />
                     </Col>
                  </Grid>
               </Col>
            </Grid>
         </SecBody>
      </>
   );
};

const SecBody = styled.div`
   // background: plum;
   padding: 1em;
   border-bottom: 1px solid rgba(100, 100, 100, 0.3);

   & .division {
      width: 100%;
      margin-bottom: 2em;
      background: red;
   }

   & .imagesInput {
      .row {
         width: 100%;
      }
   }

   & .labelMargin {
      margin-bottom: 1em;
   }
   & .labelTitle {
      font-size: 1.2em;
      margin-bottom: 1em;
   }

   & .labelText {
      font-weight: 400;
   }
`;
